import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import shopReducer from './shopSlice';
import menuReducer from './menuSlice';
import uiReducer from './uiSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    shop: shopReducer,
    menu: menuReducer,
    ui: uiReducer
  }
});

export default store;
